export default __webpack_public_path__ + "static/media/DISS-CO_TOM_Without-Highlight.488576cb.pdf";